/*
 * Application global variables.
 */

// Set Font Awesome font path
// $fa-font-path: "~@fortawesome/fontawesome-free/webfonts";

// ---------------------------------------------------------------------------
// Bootstrap variables
//
// Override Bootstrap variables here to suite your theme.
// Copy variables you want to customize from node_modules/bootstrap/scss/_variables.scss

// @import "bootstrap/scss/functions";

//
// Color system
//

/*************************/
$font-size-sm : 11px;
$font-size-md : 13px;
$font-size-lg : 15px;
$font-size-xlg : 17px;

// Navigation
$primary-text-color : #89465A;
$primary-costa-color: #6B1831;
$secondary-costa-color : #6B18311A;


$width-100 : 100%;
$height-100 : 100%;
$navbar-bg-color : white;
$display-none : none;
$display-flex : flex;
$flex-direction-column : column;
$justify-content-space-between : space-between;

$white: #fff;
$gray-100: #f8f9fa;
$gray-200: #e9ecef;
$gray-300: #dee2e6;
$gray-400: #ced4da;
$gray-500: #adb5bd;
$gray-600: #868e96;
$gray-700: #495057;
$gray-800: #343a40;
$gray-900: #212529;
$gray-93: #EDEDED;
$gray-92: #EBEBEB;
$gray-97: #F7F7F8;
$gray98: #fafafa;
$gray-44: #707070;
$red-1: #dc3545;


$gray-1: #ddd;
$gray-2: #B9B9B9;
$gray-3: #7F7F7F;
$gray-4: #808080;
$gray-5: #eee;

$black: #000;

$blue: #175384;
$indigo: #6610f2;
$purple: #6f42c1;
$pink: #e83e8c;
$red: #c05268;
$orange: #fd7e14;
$yellow: #be8f04;
$green: #089769;
$teal: #20c997;
$cyan: #17a2b8;


/****************************/
$primary: #6A1B9A;
$secondary:$gray-100;
$ternary: #e2efd9;
$font-color-1: #000000;
$font-color-2:black;
$btn-bg: #fb471f;
$main-card-bg:#ffffff;
$card-icons-color:#fb471f;
/***************************/


$cards-bg: $ternary;
$success: #089769;
$info: $cyan;
$warning: $primary;
$danger: #DB0006;
$light: $white;
$dark: $black;

$theme-colors: (
  primary: $primary,
  secondary: $secondary,
  success: $success,
  info: $info,
  warning: $warning,
  danger: $danger,
  light: $light,
  dark: $dark,
);

$bg-success: #e5fff2;
$bg-danger: #fdeaee;
$bg-warning: #fff4d3;
$bg-default: #e7e3e4;
$border-color: #D6D6D6;
$search-icon-color: #a3a3a3;
$loader-color: #363333;
$loader-background: #e6e6e6;
$spinner-border-width-sm: 0.1em;
$box-shadow: #00000029;
$smoke-white: #EFEFEF;
$warm-white: #f1f1f1;
$strong-red: #e60d0d;
$black-mana: #868686;
$gainsboro: #dcdcdc;
$safetyOrange: #FF6702;


// @import "bootstrap/scss/variables";
// @import "bootstrap/scss/mixins";

$app-text-color: $black;
$app-border-color: $gray-400;
$vit-text-color: #FFBC0D;
$scroll-track-bg: $gray-100;
$scroll-thumb-bg: $blue;
$scroll-thumb-hover-bg: $blue;
$error-highlight: #fbe3e4;
$warning-highlight: $bg-warning;
$saved-text:#777777;
$saved-background: #F5F5F5;
$submitted-text:#029039;
$submitted-background: #E4EFE8;
$cancelled-text:#E22900;
$cancelled-background: #F8E1DC;
$read-only-card: #c0e4f7;


$cement-1: #999;
$cement-2: #676767;
$cement-3: #22232299;
$bg-white-1: $ternary;
$black-1: $font-color-1;
$black-3: #00000080;
$black-4: #222322;
$black-5: #2A2A2A;
$black-6: #2223221A;
$black-7: #22232226;
$bg-red-1: $primary;
$white-1: #ffff;
$white-2: #d1cccc;
$black-2: #3c3c3c;
$gray-6: #888;
$gray-7: #555;
$gray-8: #ccc;
$gray-9: #8e8e8e;
$gray-10: #6f7070;
$gray-11:#646464;
$gray-12:#E8E8E8;
$red-2:#da1919;
$ashgray: #F2F2F2;
$ashgray-2: #F1F2F2;
$bg-input:#E3E3E3;
$gray-94: #F0F0F0;
$gray-disable: #D0D0D0;
$green-arrow-icon: #32AC70;
$red-arrow-icon: #E52F25;
